BaseModel = require './base_model.coffee'

class global.NectarSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    pipeline: {}
    stage_id: {}
    triggers: { default: { on_created: false, status: ['connected'], stages: ['lost'] }, type: Object }
    pipeline_id: {}
    stage_number: {}
    create_on_add: {}
    send_tasks: { default: true }
    responsible: {}
  }



// WEBPACK FOOTER //
// ./src/models/nectar_setting.coffee